export default __webpack_public_path__ + "static/media/Helm of Fearless Souls.fe769512.jpg";